/**
 * Footer Component
 * App footer with links and copyright
 */

import React from 'react';
import {
  FooterContainer,
  FooterContent,
  FooterLink,
  FooterBottom,
  FooterLinks,
  FooterCopyright,
} from './footer.styles';

/**
 * Footer component
 */
export const Footer: React.FC = () => {
  return (
    <FooterContainer>
      <FooterContent>
        <FooterBottom>
          <FooterLinks>
            <FooterLink href="/info">About</FooterLink>
            <FooterLink href="/legal/contact-us">Contact</FooterLink>
            <FooterLink href="/legal/terms-of-service">Terms</FooterLink>
          </FooterLinks>
          <FooterCopyright>
            ©{new Date().getFullYear()} Lat Long Labs
          </FooterCopyright>
        </FooterBottom>
      </FooterContent>
    </FooterContainer>
  );
};
